import React from 'react';
import PropTypes from 'prop-types';

export const NameAndEmail = ({ item }) => (
  <span>
    {`${item.firstName} ${item.lastName}`}
    &nbsp; (
    <strong>{item.email}</strong>
)
  </span>
);

NameAndEmail.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default NameAndEmail;
